import * as React from 'react';

export const useQuery = () => {

    const getQueryObject = () => {
        const searchParams = new URLSearchParams(location.search);
        const query: Record<string, string> = {};
        
        for (const [key, value] of searchParams.entries()) {
            query[key] = value;
        }
        
        return query;
    }

    React.useEffect(() => {
        if (window.history.pushState) {
            const pushState = history.pushState;
            history.pushState = function (state) {
                // @ts-ignore
                if (typeof history.onpushstate == "function") {
                    // @ts-ignore
                    history.onpushstate({state: state});
                }
                const value = pushState.apply(history, arguments);
                setQuery(getQueryObject());
                return value;
            }
        }
    }, []);

    const [query, setQuery] = React.useState(getQueryObject());

    const setQueryParam = (query: object, handle?: 'merge') => {
        let searchParams = new URLSearchParams(window.location.search);
        
        if (handle !== 'merge') {
            // Clear all existing params
            searchParams = new URLSearchParams();
        }

        // Set new params
        for (const key of Object.keys(query)) {
            const value = query[key];
            if (value !== null && value !== undefined && value !== '') {
                searchParams.set(key, String(value));
            } else {
                searchParams.delete(key);
            }
        }

        const queryString = searchParams.toString();
        const newurl = window.location.protocol + "//" + 
                      window.location.host + 
                      window.location.pathname + 
                      (queryString ? '?' + queryString : '');
        
        setQuery(getQueryObject());
        window.history.pushState({path: newurl}, '', newurl);
    }

    return [query, setQueryParam] as const;
}